import { Component, OnInit, ElementRef } from '@angular/core';
import { DatalayerService } from 'src/services/datalayer.service';

@Component({
  selector: 'app-cpj-container',
  templateUrl: './cpj-container.component.html',
  styleUrls: ['./cpj-container.component.scss']
})
export class CpjContainerComponent implements OnInit {

  constructor(
    private elementRef: ElementRef,
    private datalayerService: DatalayerService
  ) {}

  ngOnInit(): void {
    this.enableClickDelegation();
  }

  ngAfterViewInit(): void {
    this.prepareCpjLinks();
  }

  private enableClickDelegation(): void {
    this.elementRef.nativeElement.addEventListener('click', (event: any) => {
      const link = event.target.closest('[data-cpj-link]');
      if (!link) return;

      const linkText = link.getAttribute('data-link-text');
      const linkUrl = link.getAttribute('data-link-url');
      const articleTitle = link.getAttribute('data-article-title');

      this.cpjClick(linkText, linkUrl, articleTitle);
      window.open(linkUrl, '_blank');
    });
  }

  private prepareCpjLinks(): void {
    const host = this.elementRef.nativeElement as HTMLElement;

    const entries = host.querySelectorAll('.entries a');
    entries.forEach(link => {
      const linkEl = link as HTMLElement; // cast to HTMLElement
      const linkText = (linkEl.textContent || '').trim();
      const linkUrl = linkEl.getAttribute('href') || '';

      let current = linkEl.parentElement?.previousElementSibling as HTMLElement | null;
      let articleTitle = '';

      while (current) {
        if (current.matches('h3.entry-title')) {
          articleTitle = current.textContent?.trim() || '';
          break;
        }
        current = current.previousElementSibling as HTMLElement | null;
      }

      const span = document.createElement('span');
      span.textContent = linkText;
      span.style.cursor = 'pointer';
      span.style.textDecoration = 'underline';
      span.style.color = '#00819E';
      span.style.display = 'block';
      span.style.textAlign = 'right';

      span.setAttribute('data-cpj-link', 'true');
      span.setAttribute('data-link-text', linkText);
      span.setAttribute('data-link-url', linkUrl);
      span.setAttribute('data-article-title', articleTitle);

      linkEl.replaceWith(span);
    });
  }

  cpjClick(linkText: string, linkUrl: string, articleTitle: string) {
    this.datalayerService.cpjClick(linkText, linkUrl, articleTitle);
  }
}